import React, { useEffect, useRef, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialCarousel = () => {
  const containerRef = useRef(null);

  // Wrap testimonials with useMemo so it doesn’t change on every render
  const testimonials = useMemo(() => [
    {
      name: "Richard Leland",
      position: "– Director of Strategic Branding, NASA",
      message:
        "At NASA, names carry weight—they need to inspire, endure, and communicate a sense of mission. Brand Acumen brings the same level of precision and vision to name development that we applied to our most ambitious space programs"
    },
    {
      name: "Alan Patricof",
      position: "Founder, Greycroft & Apax Partners",
      message:
        "Their deep understanding of investor psychology and regulatory constraints makes them the smartest choice for biotech and tech firms looking to build billion-dollar brands."
    },
    {
      name: "Mary Minnick",
      position: "Former CMO Coca-Cola",
      message:
        "Bill has authored a wide variety of naming conventions for Coca-Cola including master brands, sub-brands, descriptive identities, and flavor names. I would have no hesitation in recommending Bill to any food and beverage company who needs marketing support of any kind."
    }
  ], []);

  useEffect(() => {
    const calculateMaxHeight = () => {
      if (!containerRef.current) return;

      const testimonialContents = containerRef.current.querySelectorAll(".testimonial-content");
      if (!testimonialContents.length) return;

      testimonialContents.forEach(el => (el.style.minHeight = "auto"));

      const heights = Array.from(testimonialContents).map(el => el.offsetHeight);
      const maxHeight = Math.max(...heights);

      testimonialContents.forEach(el => {
        el.style.minHeight = `${maxHeight}px`;
      });
    };

    const timer = setTimeout(calculateMaxHeight, 100);

    window.addEventListener("resize", calculateMaxHeight);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", calculateMaxHeight);
    };
  }, [testimonials]); 

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <section className="py-3">
      <div className="container text-center" ref={containerRef}>
        <h2 className="mb-4 font-bold">Our Testimonials</h2>
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div className="item d-flex align-items-stretch px-2" key={index}>
              <div className="testimonial w-100 d-flex flex-column justify-content-between">
                <div className="testimonial-content position-relative">
                  <div className="testimonial-icon">
                    <i className="bi bi-quote"></i>
                  </div>
                  <p className="description">{testimonial.message}</p>
                </div>
                <div className="mt-3">
                  <h3 className="title">{testimonial.name}</h3>
                  <span className="post">{testimonial.position}</span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialCarousel;
